import { render, staticRenderFns } from "./ResearchApprove.vue?vue&type=template&id=6a8deadd"
import script from "./ResearchApprove.vue?vue&type=script&lang=js"
export * from "./ResearchApprove.vue?vue&type=script&lang=js"
import style0 from "./ResearchApprove.vue?vue&type=style&index=0&id=6a8deadd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports